import styled from 'styled-components';

import { baseFontFamily, baseFontSize, baseLineHeight } from 'views/services/font-scheme';
import { primaryColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

interface Height { height: string; }

export const Root = styled.div`
  font-family: ${baseFontFamily};
  font-size: ${baseFontSize};
  line-height: ${baseLineHeight};
  color: ${primaryColor};
  background-image: url(${backgroundImage});
  background-repeat: repeat-x;
`;

export const Layout = styled.div<Height>`
  margin: 0 auto;
  position: relative;
  width: 924px;
  height: ${p => p.height};
`;

export const Logo = styled.div`
  position: absolute;
  top: 11px;
`;

export const Company = styled.div`
  position: absolute;
  right: 0;
  top: 26px;
  font-size: 1.5em;
`;

export const Slogan = styled.div`
  position: absolute;
  right: 180px;
  top: 33px;
  font-size: 1.0em;
`;

export const Menu = styled.div`
  position: absolute;
  right: 0;
  top: 79px;
  & > ul > li {
    float:  left;
    margin: 0 0 0 32px;
  }
`;
